import { read, utils } from 'xlsx';

const REQUIRED_COLUMNS = [
  'CNPJ',
  'Código',
  'Sequência',
  'Nome'
];

export const validateExcelColumns = async (file: File): Promise<{
  isValid: boolean;
  missingColumns: string[];
}> => {
  try {
    const data = await file.arrayBuffer();
    const workbook = read(data);
    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData: any = utils.sheet_to_json(firstSheet, { header: 1 });
    
    const headers = (jsonData[0] || []) as string[];
    const missingColumns = REQUIRED_COLUMNS.filter(
      col => !headers.includes(col)
    );
    
    return {
      isValid: missingColumns.length === 0,
      missingColumns
    };
  } catch (error) {
    return {
      isValid: false,
      missingColumns: REQUIRED_COLUMNS
    };
  }
};

